import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LoadingService } from "src/app/core/services/loading.service";

@Component({
  selector: "app-loading",
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
})
export class LoadingComponent {
  // Injections
  readonly loadingService = inject(LoadingService);

  // Inputs
  readonly hasBackgound = input<boolean>(true);
  readonly isClean = input<boolean>(false);
  readonly textLabel = input<string>();
}
